import { css as t } from "styled-components";
var i = /* @__PURE__ */ ((n) => (n.xs = "xs", n.sm = "sm", n.md = "md", n.lg = "lg", n.xl = "xl", n.xxl = "xxl", n))(i || {});
const x = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 1024,
  xl: 1224,
  xxl: 1824
}, b = (n) => `(min-width: ${x[n]}px)`, a = (n, r) => n === "xs" ? r : t`
        @media ${b(n)} {
          ${r}
        }
      `, k = (n, r) => {
  const l = Object.keys(i).reduce((f, d, c) => Object.keys(n).includes(d) ? [...f, d] : [...f, f[c - 1]], []), $ = Object.keys(i).findIndex((f) => f === r);
  return l[$];
}, y = (n) => {
  if (n) {
    if (Array.isArray(n))
      return n;
    if (typeof n == "object")
      return Object.entries(n).map(
        ([r, l]) => a(r, l)
      );
  }
}, v = (n) => t`
  ${(r) => Object.entries(r).filter((l) => {
  const [$, f] = l;
  return !!n[$] && !!f;
}).map(([l, $]) => typeof $ == "object" ? Object.entries($).map(
  ([f, d]) => a(f, n[l](d))
) : y(n[l]($)))}
`, h = {
  black: "#222",
  white: "#fff",
  grey: "#f7f7f7",
  whiteAlpha10: "rgba(255, 255, 255, .1)",
  whiteAlpha40: "rgba(255, 255, 255, .4)",
  whiteAlpha60: "rgba(255, 255, 255, .6)",
  whiteAlpha80: "rgba(255, 255, 255, .8)",
  greyAlpha10: "rgba(0, 0, 0, .1)",
  greyAlpha40: "rgba(0, 0, 0, .4)",
  greyAlpha60: "rgba(0, 0, 0, .6)",
  greyAlpha80: "rgba(0, 0, 0, .8)",
  redAlert: "#d70c00",
  redAlertLight: "#fbe7e6",
  redBrand: "#900",
  redBrandLight: "#f5e6e6",
  positiveTealDark: "#0a7f7f",
  positiveTealLight: "#e7f2f2",
  turquoiseLight: "#1cd6d9",
  transparent: "rgba(255, 255, 255, 0)",
  focus: "#828282",
  silverLight: "#e1e1e1"
}, p = {
  dominant: "hsl(var(--c-dominant-base))",
  dominantAlpha10: "hsla(var(--c-dominant-base), .1)",
  dominantAlpha40: "hsla(var(--c-dominant-base), .4)",
  dominantAlpha60: "hsla(var(--c-dominant-base), .6)",
  dominantAlpha80: "hsla(var(--c-dominant-base), .8)",
  accent: "hsl(var(--c-accent-base))",
  accentAlpha10: "hsla(var(--c-accent-base), .1)",
  accentAlpha40: "hsla(var(--c-accent-base), .4)",
  accentAlpha60: "hsla(var(--c-accent-base), .6)",
  accentAlpha80: "hsla(var(--c-accent-base), .8)"
}, A = {
  dominant: h.black,
  dominantAlpha10: h.greyAlpha10,
  dominantAlpha40: h.greyAlpha40,
  dominantAlpha60: h.greyAlpha60,
  dominantAlpha80: h.greyAlpha80,
  accent: h.white,
  accentAlpha10: h.whiteAlpha10,
  accentAlpha40: h.whiteAlpha40,
  accentAlpha60: h.whiteAlpha60,
  accentAlpha80: h.whiteAlpha80
}, m = (n, r, l) => t`
  ${`${n}: ${A[r]} ${l || ""};`}
  ${`${n}: ${p[r]} ${l || ""};`}
`, g = {
  long: "2s",
  base: "1s",
  short: ".5s",
  shorter: ".3s",
  shortest: ".15s"
}, z = "cubic-bezier(.39, .58, .57, 1)", j = "cubic-bezier(0.11, 0, 0.5, 0)", u = (n, r = g.shorter, l = z) => t`
  transition-duration: ${r};
  transition-property: ${n};
  transition-timing-function: ${l};

  @media (prefers-reduced-motion) {
    transition: none;
  }
`;
var w = /* @__PURE__ */ ((n) => (n.headingXlSans = "heading-xl-sans", n.headingXlSerif = "heading-xl-serif", n.headingLSerif = "heading-l-serif", n.headingMSerif = "heading-m-serif", n.headingMSans = "heading-m-sans", n.headingSSerif = "heading-s-serif", n.headingSSerifM = "heading-s-serif-m", n.headingSSans = "heading-s-sans", n.headingXsSerif = "heading-xs-serif", n.headingXsSans = "heading-xs-sans", n.body = "body", n.bodyMedium = "body-medium", n.bodyS = "body-s", n.bodyXS = "body-xs", n.bodySMedium = "body-s-medium", n.label = "label", n.labelMedium = "label-medium", n.labelS = "label-s", n.labelSMedium = "label-s-medium", n.action = "action", n.actionL = "action-l", n))(w || {});
const o = {
  primary: "ABCArizonaSerif",
  secondary: "ABCArizonaSans"
}, s = {
  thin: 100,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
}, e = (n) => `${(typeof n == "string" ? parseFloat(n) : n) / 16}rem`, C = {
  default: t`
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  `,
  underline: t`
    ${u("color", g.shortest)}

    text-decoration: underline;

    &:hover {
      text-decoration: none;
      ${m("color", "dominantAlpha80")};
    }

    &:active {
      ${m("color", "dominantAlpha60")};
    }
  `,
  dark: t`
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      color: ${h.greyAlpha80};
    }

    &:active {
      color: ${h.greyAlpha60};
    }
  `
}, L = (n) => {
  const r = {
    "heading-xl-serif": t`
      ${a(
      i.xs,
      t`
          font-family: ${o.primary};
          font-style: normal;
          font-weight: ${s.light};
          font-size: ${e(32)};
          line-height: ${e(40)};
        `
    )}
      ${a(
      i.xl,
      t`
          font-size: ${e(48)};
          line-height: ${e(58)};
        `
    )}
      ${a(
      i.xxl,
      t`
          font-size: ${e(64)};
          line-height: ${e(76)};
        `
    )}
    `,
    "heading-xl-sans": t`
      ${a(
      i.xs,
      t`
          font-family: ${o.secondary};
          font-style: normal;
          font-weight: ${s.normal};
          font-size: ${e(32)};
          line-height: ${e(38.4)};
        `
    )}
      ${a(
      i.xl,
      t`
          font-size: ${e(44)};
          line-height: ${e(52.8)};
        `
    )}
      ${a(
      i.xxl,
      t`
          font-size: ${e(54)};
          line-height: ${e(64.8)};
        `
    )}
    `,
    "heading-l-serif": t`
      ${a(
      i.xs,
      t`
          font-family: ${o.primary};
          font-style: normal;
          font-weight: ${s.light};
          font-size: ${e(24)};
          line-height: ${e(30)};
        `
    )}
      ${a(
      i.xl,
      t`
          font-size: ${e(32)};
          line-height: ${e(40)};
        `
    )}
      ${a(
      i.xxl,
      t`
          font-size: ${e(48)};
          line-height: ${e(58)};
        `
    )}
    `,
    "heading-m-serif": t`
      ${a(
      i.xs,
      t`
          font-family: ${o.primary};
          font-style: normal;
          font-weight: ${s.light};
          font-size: ${e(20)};
          line-height: ${e(24)};
        `
    )}
      ${a(
      i.xl,
      t`
          font-size: ${e(24)};
          line-height: ${e(28)};
        `
    )}
      ${a(
      i.xxl,
      t`
          font-size: ${e(32)};
          line-height: ${e(40)};
        `
    )}
    `,
    "heading-m-sans": t`
      ${a(
      i.xs,
      t`
          font-family: ${o.secondary};
          font-style: normal;
          font-weight: ${s.light};
          font-size: ${e(18)};
          line-height: ${e(24)};
        `
    )}
      ${a(
      i.xl,
      t`
          font-size: ${e(20)};
          line-height: ${e(28)};
        `
    )}
      ${a(
      i.xxl,
      t`
          font-size: ${e(28)};
          line-height: ${e(40)};
        `
    )}
    `,
    "heading-s-serif": t`
      ${a(
      i.xs,
      t`
          font-family: ${o.primary};
          font-style: normal;
          font-weight: ${s.light};
          font-size: ${e(18)};
          line-height: ${e(22)};
        `
    )}
      ${a(
      i.xl,
      t`
          font-size: ${e(20)};
          line-height: ${e(24)};
        `
    )}
    `,
    "heading-s-serif-m": t`
      ${a(
      i.xs,
      t`
          font-family: ${o.primary};
          font-style: normal;
          font-weight: ${s.normal};
          font-size: ${e(18)};
          line-height: ${e(22)};
        `
    )}
      ${a(
      i.xl,
      t`
          font-size: ${e(20)};
          line-height: ${e(24)};
        `
    )}
    `,
    "heading-s-sans": t`
      ${a(
      i.xs,
      t`
          font-family: ${o.secondary};
          font-style: normal;
          font-weight: ${s.light};
          font-size: ${e(16)};
          line-height: ${e(22)};
        `
    )}
      ${a(
      i.xl,
      t`
          line-height: ${e(24)};
        `
    )}
      ${a(
      i.xxl,
      t`
          font-size: ${e(18)};
        `
    )}
    `,
    "heading-xs-serif": t`
      ${a(
      i.xs,
      t`
          font-family: ${o.primary};
          font-style: normal;
          font-weight: ${s.light};
          font-size: ${e(16)};
          line-height: ${e(20)};
          letter-spacing: -0.001em;
        `
    )}
      ${a(
      i.xxl,
      t`
          font-size: ${e(18)};
          line-height: ${e(24)};
        `
    )}
    `,
    "heading-xs-sans": t`
      ${a(
      i.xs,
      t`
          font-family: ${o.secondary};
          font-style: normal;
          font-weight: ${s.light};
          font-size: ${e(14)};
          line-height: ${e(20)};
        `
    )}
      ${a(
      i.xxl,
      t`
          font-size: ${e(20)};
          line-height: ${e(28)};
        `
    )}
    `,
    body: t`
      ${a(
      i.xs,
      t`
          font-family: ${o.secondary};
          font-style: normal;
          font-weight: ${s.light};
          font-size: ${e(14)};
          line-height: ${e(20)};
        `
    )}
    `,
    "body-medium": t`
      ${a(
      i.xs,
      t`
          font-family: ${o.secondary};
          font-style: normal;
          font-weight: ${s.normal};
          font-size: ${e(14)};
          line-height: ${e(20)};
        `
    )}
    `,
    "body-s": t`
      ${a(
      i.xs,
      t`
          font-family: ${o.secondary};
          font-style: normal;
          font-weight: ${s.light};
          font-size: ${e(12)};
          line-height: ${e(18)};
        `
    )}
    `,
    "body-xs": t`
      ${a(
      i.xs,
      t`
          font-family: ${o.secondary};
          font-style: normal;
          font-weight: ${s.light};
          font-size: ${e(10)};
          line-height: ${e(12.1)};
        `
    )}
    `,
    "body-s-medium": t`
      ${a(
      i.xs,
      t`
          font-family: ${o.secondary};
          font-style: normal;
          font-weight: ${s.normal};
          font-size: ${e(12)};
          line-height: ${e(18)};
        `
    )}
    `,
    label: t`
      ${a(
      i.xs,
      t`
          font-family: ${o.secondary};
          font-style: normal;
          font-weight: ${s.light};
          font-size: ${e(12)};
          line-height: ${e(18)};
          text-transform: uppercase;
        `
    )}
    `,
    "label-medium": t`
      ${a(
      i.xs,
      t`
          font-family: ${o.secondary};
          font-style: normal;
          font-weight: ${s.medium};
          font-size: ${e(12)};
          line-height: ${e(18)};
          text-transform: uppercase;
        `
    )}
    `,
    "label-s": t`
      ${a(
      i.xs,
      t`
          font-family: ${o.secondary};
          font-style: normal;
          font-weight: ${s.normal};
          font-size: ${e(10)};
          line-height: ${e(18)};
          text-transform: uppercase;
        `
    )}
    `,
    "label-s-medium": t`
      ${a(
      i.xs,
      t`
          font-family: ${o.secondary};
          font-style: normal;
          font-weight: ${s.medium};
          font-size: ${e(10)};
          line-height: ${e(18)};
          text-transform: uppercase;
        `
    )}
    `,
    action: t`
      ${a(
      i.xs,
      t`
          font-family: ${o.secondary};
          font-style: normal;
          font-weight: ${s.medium};
          font-size: ${e(12)};
          line-height: ${e(18)};
          text-transform: uppercase;
        `
    )}
    `,
    "action-l": t`
      ${a(
      i.xs,
      t`
          font-family: ${o.secondary};
          font-style: normal;
          font-weight: ${s.light};
          font-size: ${e(16)};
          line-height: ${e(24)};
          text-transform: uppercase;
        `
    )}
    `
  };
  return n ? r[n] : r.body;
}, M = (n) => t`
  width: ${typeof n == "number" ? e(n) : n};
  height: ${typeof n == "number" ? e(n) : n};
`, O = (n) => t`
  @media (prefers-contrast: more) {
    ${n}
  }
`, X = (n) => t`
  transform: rotate(${n}deg);
`, F = (n) => t`
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${n};
`;
export {
  i as B,
  w as T,
  a,
  x as b,
  h as c,
  m as d,
  g as e,
  k as f,
  v as g,
  y as h,
  j as i,
  u as j,
  o as k,
  s as l,
  b as m,
  C as n,
  L as o,
  O as p,
  F as q,
  e as r,
  M as s,
  z as t,
  X as u
};
